import { getSportingServiceURL } from 'services/sporting/utils/getSportingURL';
import { customFetch } from 'utils/customFetch';
import { UnexpectedError } from 'utils/errors';
import { createSportingHeaders } from 'services/sporting/utils/createSportingHeaders';

export const getParticipationsCountForNearCompetitions = async (): Promise<number[]> => {
  const endpointURL = getSportingServiceURL(
    `getParticipationsCountForNearCompetitions`
  );

  const headers = createSportingHeaders();

  const response = await customFetch(endpointURL, { headers });

  if (!response.ok) {
    throw new UnexpectedError();
  }

  if (response.status === 200) {
    return response.json();
  }

  return [];
};
